import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActionCard = ({ icon, iconColor, title, description, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="
        w-full bg-card border border-border rounded-lg shadow-md p-4 md:p-5
        transition-smooth hover-lift hover:shadow-lg press-scale
        text-left
      "
    >
      <div className="flex items-start gap-3 md:gap-4">
        <div className="flex items-center justify-center h-12 w-12 md:h-14 md:w-14 rounded-lg bg-primary/10 flex-shrink-0">
          <Icon name={icon} size={24} color={iconColor} strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
            {title}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
        <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" />
      </div>
    </button>
  );
};

export default QuickActionCard;